import React from 'react'
import type { UseListResult } from '@ztechapps/common.hook'
import { TaskStatusSummaryTabs } from './TaskStatusSummaryTabs'
import { TaskFilterBarInline } from './TaskFilterBarInline'

type TaskFilterBarProps = {
  listAction?: UseListResult<any>
  leadingActions?: React.ReactNode
}

/**
 * TaskFilterBar renders the status summary tabs and the shared filter/search bar.
 * Shared across List, Board, and Calendar views.
 *
 * @param listAction - the useList result from the page context, provides onSearch/onFilter for the DataTool search
 * @param leadingActions - optional slot for view-specific controls (e.g., GroupByDropdown for board view)
 */
export const TaskFilterBar = ({ listAction, leadingActions }: TaskFilterBarProps) => {
  return (
    <>
      <TaskStatusSummaryTabs />
      <TaskFilterBarInline listAction={listAction} leadingActions={leadingActions} />
    </>
  )
}
